import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'

const ImageLoader = styled(LoadingBox)`
  min-height: ${rem(155)};
`

const SectionPane = styled.div`
  border: none;
  padding: ${rem(20)};
  margin: ${rem(4)} 0;
  display: grid;

  ${mediaQueryUp.tablet} {
    width: ${rem(560)};
    padding: ${rem(24)};
    gap: ${rem(20)};
  }
`

function CarHireLocationModalSkeleton() {
  return (
    <VerticalSpacer gap={16}>
      <ImageLoader />
      <SectionPane>
        <div>
          <TextLoadingBox typography="heading2" lines={1} width="100%" />
          <TextLoadingBox typography="body-small" lines={3} width="100%" />
        </div>

        <div>
          <TextLoadingBox typography="heading2" lines={1} width="100%" />
          <TextLoadingBox typography="body-small" lines={3} width="100%" />
        </div>
      </SectionPane>
    </VerticalSpacer>
  )
}

export default CarHireLocationModalSkeleton
